import { render, staticRenderFns } from "./TextLayerBeside.vue?vue&type=template&id=03906981&functional=true&"
import script from "./TextLayerBeside.vue?vue&type=script&lang=ts&"
export * from "./TextLayerBeside.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports